import "./Search.scss";
import svg from "../../assets/img/sprite.svg";
import { SearchResults } from "../SearchResults/SearchResults";
import { ChangeEvent, FC, useState } from "react";
import { movieApi } from "../../redux/services/movieApi";


interface SearchProps {
  setSearchVisible:(value:boolean)=> void
}

export const Search:FC<SearchProps> = ({setSearchVisible}) => {

  const [searchParam, setSearchParam] = useState('')
  const { data: moviesSearch, isLoading, error, refetch } = movieApi.useGetMoviesQuery({ title: searchParam, count: 5 })


  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchParam(e.target.value)
  }

  const handleClear = () => { 
    setSearchParam('');
    setSearchVisible(false);
  };

  return (
    <div className="search">
      <input value={searchParam}
        className="search__field"
        placeholder="Поиск"
        onChange={handleSearch}
      />
      <svg className="search__icon" width="20" height="20" fill="none">
        <use xlinkHref={`${svg}#search`}></use>
      </svg>
      <ul className={searchParam.length >= 1 ? 'search-result open' : 'search-result'}>
        {isLoading && <div>...загрузка</div>}
        {error &&
          <div>
            <h2 style={{ marginBottom: "10px" }}> Произошла ошибка</h2> <button className='btn btn-dark' onClick={() => refetch()}>Обновить список</button>
          </div>}
        {moviesSearch  && moviesSearch.length > 1 ? (
          moviesSearch.map((movieSearch) =>
            <li className="search-result__item" key={movieSearch.id}>
              <SearchResults  setSearchVisible={setSearchVisible} movieSearch={movieSearch} setSearchParam={setSearchParam} />
            </li>
          )
        ) : (
          <div>По Вашему запросу ничего не найдено</div>
        )}
      </ul>
      <button onClick={handleClear} className="search__clear-btn">
        <svg className="search__clear-svg" width="14" height="14" fill="none">
          <use xlinkHref={`${svg}#X`}></use>
        </svg>
      </button>
    </div>

  );
};
